import { render, staticRenderFns } from "./ResendInvitation.vue?vue&type=template&id=0d5123a8"
import script from "./ResendInvitation.vue?vue&type=script&lang=js"
export * from "./ResendInvitation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports